import { googleLogin } from "../firebase/firebaseController";

export const LOGIN_ATTEMP = "LOGIN_ATTEMP";
export const LOGIN_ATTEMP_ERROR = "LOGIN_ATTEMP_ERROR";
export const LOGIN_ATTEMP_SUCCESS = "LOGIN_ATTEMP_SUCCESS";

//logout
export const LOGGING_OUT = "LOGGING_OUT";
export const LOGGING_OUT_SUCCESS = "LOGGING_OUT_SUCCESS";
export const LOGGING_OUT_ERROR ="LOGGING_OUT_ERROR"


export const loginAttemp= ()=>({
    type:LOGIN_ATTEMP
})

export const loginAttempError = (error) =>({
    type: LOGIN_ATTEMP_ERROR,
    payload: error
})

export const loginAttempSuccess = (user) =>({
    type: LOGIN_ATTEMP_SUCCESS,
    payload: user
})


export const loginWithGoogle =()=>{
    return async function (dispatch, getState, args){
        try{
            dispatch(loginAttemp());
            let userData = await googleLogin();
            let loginUser = {
                name: userData.user.displayName,
                email: userData.user.email,
                image: userData.user.photoURL
            }
            dispatch(loginAttempSuccess(loginUser))
        }
        catch(e){
            console.log(e.message);
            dispatch(loginAttempError(e.message));
        }
    }
}

export const loggingOut=()=>({
    type: LOGGING_OUT
})

export const loggingOutSuccess=()=>({
    type: LOGGING_OUT_SUCCESS    
})

export const loggingOutError=(error)=>({
    type: LOGIN_ATTEMP_ERROR,
    payload: error
})



